module.exports = __webpack_public_path__ + "img/hzhs6.19078cb6.jpg";